export const getContacts = state => state.contacts